import React from 'react';
import { object, arrayOf } from 'prop-types';
import styled from 'styled-components';

import Navbar from './NavbarContainer';
import LandingHeader from './LandingHeader';
import Reasons from './ReasonBox';
import Products from './PlanBox';
import Benefits from './BenefitBoxContainer';
import Testimonials from './TestimonialBox';
import QuestionsBox from '../../core/components/questions/QuestionsBox';
import CommunicationBox from './CommunicationBoxContainer';
import { isNotWebview } from '../../core/libs/browser/browser';

const Container = styled.div`
  width: 100%;
  display: block;
  margin: 0 auto;
`;

const Landing = ({
  posData,
  productsData,
  contentData,
  navItems,
}) => {
  const {
    headerImage: image, title, subtitle, reasons, benefits, testimonials, questions, telesales, showTelesales, infoDetail: info, message,
  } = contentData;
  const { parentName, funnelId } = posData;
  const { subscriptions, subscriptionList } = productsData;

  return (
    <Container>
      <Navbar items={navItems} right sticky />
      <LandingHeader image={image} title={title} subtitle={subtitle} />
      <Reasons reasons={reasons} />
      <Products posName={parentName} subscriptions={subscriptions} info={info} message={message} showDropdown={subscriptionList.length > 3} />
      <Benefits benefits={benefits} />
      {isNotWebview && <CommunicationBox showIf={showTelesales} telesales={telesales} posName={parentName} funnelId={funnelId} />}
      <Testimonials testimonials={testimonials} />
      <QuestionsBox questions={questions} />
    </Container>
  );
};

Landing.propTypes = {
  posData: object,
  productsData: object,
  contentData: object,
  navItems: arrayOf(object),
};

Landing.defaultProps = {
  posData: {},
  productsData: {},
  contentData: {},
  navItems: [],
};

export default Landing;
